module.exports = __webpack_public_path__ + "img/login_c.5c1ac0ac.png";